import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import {
  pageResetMiddleWare,
  zodOptionalDateRange,
  zodOptionalId,
  zodPage,
} from 'routes/routeUtils';
import { compensatedBy, trackingType } from 'types/models/compensation';
import { z } from 'zod';

const pharmacyCompensationsRouteSearchSchema = z.object({
  tab: z.enum(['followUp', 'statistics']).default('followUp'),
  labId: zodOptionalId,
  year: z.number().optional(),
  followUpSubTab: z.enum(['pending', 'received']).optional(),
  trackingType: z.enum(trackingType).optional(),
  compensatedBy: z.enum(compensatedBy).optional(),
  search: z.string().optional(),
  page: zodPage,
  targetDateRange: zodOptionalDateRange,
  paidDateRange: zodOptionalDateRange,
});

export const pharmacyCompensationsRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/compensations',
  validateSearch: pharmacyCompensationsRouteSearchSchema,
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/pharmacy/Compensations/PharmacyCompensationsPage/PharmacyCompensationsPage').then(
    (d) => d.Route
  )
);
